import axios from 'axios'
import { castAttributesForSnakeCase } from '../../modules/string_converter'
import { i18n } from '../../plugins/i18n'

export const companiesBulkUpdateStoreOptions = {
  namespaced: true,
  state: {
    data: [],
    storeIds: [],
    loading: false,
  },
  getters: {
    query(state) {
      return {
        store_ids: state.storeIds,
      }
    },
  },
  mutations: {
    prepareConnect(state) {
      state.loading = true
    },
    bulkUpdateStoreOptionSuccess(state) {
      state.loading = false
    },
    readBulkUpdatesStoreOptionDifferencesSuccess(state, payload) {
      state.data = payload.data
      state.loading = false
    },
    bulkUpdateStoreOptionFailure(state) {
      state.loading = false
    },
    setStoreIds(state, ids) {
      state.storeIds = ids
    },
  },
  actions: {
    readBulkUpdatesStoreOptionDifferences({ commit, getters }, { companyUuid, query }) {
      commit('prepareConnect')
      return axios
        .post(`/api/companies/${companyUuid}/bulk_updates/store_option_differences.json`, {
          ...getters.query,
          ...castAttributesForSnakeCase(query)
        })
        .then(res => {
          commit('readBulkUpdatesStoreOptionDifferencesSuccess', res.data)
        })
        .catch(err => {
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
          console.error(err)
        })
    },
    bulkUpdateStoreOptions({ commit, getters }, { companyUuid, query }) {
      commit('prepareConnect')
      return axios
        .post(`/api/companies/${companyUuid}/bulk_update_store_options`, {
          ...getters.query,
          ...castAttributesForSnakeCase(query)
        })
        .then(() => {
          commit('bulkUpdateStoreOptionSuccess')
          commit('flash/updateFlash', { type: 'notice', message: i18n.t('messages.bulkUpdated', { value: i18n.t('models.storeOption.modelName') }) }, { root: true })
        })
        .catch(err => {
          console.error(err)
          commit('bulkUpdateStoreOptionFailure')
          commit('flash/updateFlash', { type: 'alert', message: err }, { root: true })
        })
    },
    setStoreIds({ commit }, ids) {
      commit('setStoreIds', ids)
    },
  }
}
